module.exports = __webpack_public_path__ + "static/media/Kimmy Design - CatalinaClementeRegular.7d3a9c40.otf";